<template>
  <v-container>
    <v-overlay :value="carregando" absolute>
      <v-progress-circular indeterminate color="primary" size="64" />
    </v-overlay>

    <!-- Linha com inputs -->
    <v-row>
      <v-col cols="12" md="3">
        <ValidationProvider #default="{ errors }" name="Data final">
          <v-select
            v-model="treinadorSelecionado"
            label="Treinador"
            :items="treinadores"
            item-text="nome"
            return-object
            :error-messages="errors[0]"
            outlined
            required
          />
        </ValidationProvider>
      </v-col>

      <v-col cols="12" md="3">
        <ValidationProvider #default="{ errors }" :rules="{ required: true }" name="Produto">
          <ComboBox
            v-model="produtosSelecionados"
            :items="produtosTreinador"
            @change="onValuesChange"
            :error-messages="errors[0]"
          />
          <!-- <v-select
            v-model="produto"
            label="Produto"
            :items="produtosTreinador"
            item-text="nome"
            return-object
            :error-messages="errors[0]"
            outlined
            required
          /> -->
        </ValidationProvider>
      </v-col>

      <v-col cols="12" md="3">
        <ValidationProvider #default="{ errors }" :rules="{ required: true }" name="Academia">
          <v-select
            v-model="academia"
            label="Academia"
            :items="academias"
            item-text="nome"
            return-object
            :error-messages="errors[0]"
            outlined
          />
        </ValidationProvider>
      </v-col>

      <AlertaModal v-model="mostrarAlerta" titulo="Validação" :mensagem="mensagemAlerta" />

      <v-col cols="12" md="3">
        <v-btn block color="success" height="55" width="100%" @click="salvarConfiguracao">
          <v-icon left>mdi-content-save</v-icon>Definir opcões
        </v-btn>
      </v-col>
    </v-row>
    <hr />
    <!-- Título da Seção Cards -->
    <v-row>
      <v-col cols="12">
        <h1 class="font-weight-medium">{{ this.treinadorNome ?? 'Treinador' }} - Estatísticas</h1>
      </v-col>

      <v-col cols="12" md="2">
        <v-menu
          v-model="menuDatePickerF"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <ValidationProvider #default="{ errors }" name="Data final">
              <v-text-field
                v-model="data_final"
                label="Data final"
                prepend-inner-icon="mdi-calendar"
                :error-messages="errors[0]"
                outlined
                v-bind="attrs"
                v-on="on"
              />
            </ValidationProvider>
          </template>
          <v-date-picker
            v-model="dataFinal"
            :active-picker.sync="ativarDatePicker"
            min="1900-01-01"
            locale="pt-BR"
          />
        </v-menu>
      </v-col>
      <v-col cols="6" md="2">
        <!-- Botão -->
        <v-btn color="primary" height="55" width="100%" @click="getInfosCards">
          <v-icon>mdi-finance</v-icon> Pesquisar
        </v-btn>
      </v-col>
    </v-row>
    <!-- Linha dos cards -->
    <v-row class="mt-4">
      <v-col cols="12" md="3">
        <CardInfo
          :value="nivelTreinador.nome"
          :icon="nivelTreinador.icon"
          text="Nível"
          :corAvatar="coresAcademias.academais.corAvatar"
        />
      </v-col>
      <v-col cols="12" md="3">
        <CardInfo
          :value="indicadoresTreinador.totalAlunos ?? 0"
          icon="mdi-account"
          text="Total de alunos"
          :corAvatar="coresAcademias.academais.corAvatar"
        />
      </v-col>

      <v-col cols="12" md="3">
        <CardInfo
          :value="indicadoresTreinador.valorTotalMensalidades ?? 0"
          icon="mdi-cash"
          text="Valor total mensalidades"
          :currency="true"
          :corAvatar="coresAcademias.academais.corAvatar"
        />
      </v-col>

      <v-col cols="12" md="3">
        <CardInfo
          :value="indicadoresTreinador.ltv ?? 0"
          icon="mdi-history"
          text="Ltv Total"
          :corAvatar="coresAcademias.academais.corAvatar"
        />
      </v-col>

      <v-col cols="12" md="3">
        <CardInfo
          :value="indicadoresTreinador.totalGanhos ?? 0"
          icon="mdi-trending-up"
          text="Alunos ganhos mês atual"
          :corAvatar="coresAcademias.academais.corAvatar"
        />
      </v-col>

      <v-col cols="12" md="3">
        <CardInfo
          :value="bonificacaoTreinador.bonus ?? 0"
          icon="mdi-medal"
          :text="
            bonificacaoTreinador.porcent +
            ' + ' +
            bonificacaoTreinador.fixo +
            ' - Bonificação mês atual'
          "
          :currency="true"
          :corAvatar="coresAcademias.academais.corAvatar"
        />
      </v-col>

      <v-col cols="12" md="3">
        <CardInfo
          :value="indicadoresTreinador.totalPerdidos ?? 0"
          icon="mdi-trending-down"
          text="Alunos perdidos mês atual"
          :corAvatar="coresAcademias.academais.corAvatar"
        />
      </v-col>

      <v-col cols="12" md="3">
        <CardInfo
          :value="indicadoresTreinador.totalVMConvertido + '/' + indicadoresTreinador.totalVamoMexe"
          icon="mdi-star"
          text="Vamo Mexe mês atual"
          :corAvatar="coresAcademias.academais.corAvatar"
          :action="true"
          :item="'Vamo Mexe!'"
          :index="4"
          :academiaId="0"
          :data="getDadosVamoMexe"
          @abrir-modal="abrirModal"
        />
      </v-col>
    </v-row>

    <hr />

    <v-container fluid class="pa-0 mt-4" style="height: 70vh">
      <!-- Título da Seção Transferências -->
      <v-row>
        <v-col cols="12">
          <h1 class="font-weight-medium">
            {{ this.treinadorNome ?? 'Treinador' }} - Movimentações
          </h1>
        </v-col>
        <v-col cols="12" md="2">
          <v-menu
            v-model="menuDatePickerMovIni"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <ValidationProvider #default="{ errors }" name="Data Inicial">
                <v-text-field
                  v-model="data_inicial_mov"
                  label="Data Inicial"
                  prepend-inner-icon="mdi-calendar"
                  :error-messages="errors[0]"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                />
              </ValidationProvider>
            </template>
            <v-date-picker
              v-model="dataInicialMovimentacao"
              :active-picker.sync="ativarDatePickerMov"
              min="1900-01-01"
              locale="pt-BR"
            />
          </v-menu>
        </v-col>
        <v-col cols="12" md="2">
          <v-menu
            v-model="menuDatePickerMovFin"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <ValidationProvider #default="{ errors }" name="Data final">
                <v-text-field
                  v-model="data_final_mov"
                  label="Data final"
                  prepend-inner-icon="mdi-calendar"
                  :error-messages="errors[0]"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                />
              </ValidationProvider>
            </template>
            <v-date-picker
              v-model="dataFinalMovimentacao"
              :active-picker.sync="ativarDatePickerMov"
              min="1900-01-01"
              locale="pt-BR"
            />
          </v-menu>
        </v-col>
        <v-col cols="6" md="2">
          <!-- Botão -->
          <v-btn color="primary" height="55" width="100%" @click="buscarGraficoRosca">
            <v-icon>mdi-chart-donut</v-icon> Pesquisar
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="" no-gutters>
        <!-- Coluna Gráfico -->

        <v-col cols="12" md="4" class="d-flex">
          <v-card class="fill-height d-flex flex-column justify-space-between" style="width: 100%">
            <v-card-title class="justify-center">
              {{ this.treinadorNome ?? 'Treinador' }}
            </v-card-title>
            <v-card-text class="d-flex flex-column align-center overflow-auto">
              <GraficoRosca :chart-data="chartDataTotal" />
              <v-list>
                <v-list-item v-for="(item, index) in chartDataTotal.labels" :key="index">
                  <v-list-item-icon>
                    <v-icon :style="{ color: chartDataTotal.datasets[0].backgroundColor[index] }"
                      >mdi-circle</v-icon
                    >
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item }} : {{ chartDataTotal.datasets[0].data[index] }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Coluna Lista de Alunos -->
        <v-col cols="12" md="8" class="d-flex pl-4">
          <v-card class="fill-height d-flex flex-column" style="width: 100%">
            <v-card-title>
              {{ this.treinadorNome ?? 'Treinador' }} | Lista de Movimentações de Alunos
            </v-card-title>
            <v-card-text class="pa-0" style="flex: 1; overflow-y: auto">
              <v-data-table
                :headers="headers"
                :items="alunosFormatados"
                itemKey="aluno_id"
                class="elevation-0"
                item-value="nome"
                dense
              >
                <template v-slot:[`item.produto`]="{ item }">
                  <AppProduto :value="item.produto" />
                </template>
                <template v-slot:[`item.tipo`]="{ item }">
                  <app-historico :value="item.tipo" />
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn icon @click="dialogAluno(item)">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="text-h6">{{ alunoSelecionado.nome }} |Detalhes</span>
              </v-card-title>

              <v-card-text>
                <div><strong>Nome:</strong> {{ alunoSelecionado.nome }}</div>
                <div><strong>Aniversário:</strong> {{ alunoSelecionado.aniversario }}</div>
                <div><strong>Data inicial:</strong> {{ alunoSelecionado.data_inicial }}</div>
                <div><strong>Data Final:</strong> {{ alunoSelecionado.data_final }}</div>
                <div><strong>Motivo:</strong> {{ alunoSelecionado.motivo }}</div>
                <div><strong>Academia:</strong> {{ alunoSelecionado.academia }}</div>
                <!-- coloque mais dados se quiser -->
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text @click="dialog = false">Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>

    <hr />

    <v-container>
      <!-- Título da Seção Horários -->
      <v-row>
        <v-col cols="12">
          <h1 class="font-weight-medium">{{ this.treinadorNome ?? 'Treinador' }} - Horários</h1>
        </v-col>

        <v-col cols="6" md="2">
          <!-- Botão -->
          <v-btn color="primary" height="55" width="100%" @click="buscarHorarios">
            <v-icon>mdi-calendar-month</v-icon> Pesquisar
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="(dia, index) in dadosFormatados" :key="index" cols="12" sm="6" md="4">
          <v-card @click="abrirDetalhes(dia)">
            <v-card-title class="text-h6">
              {{ dia.nome }}
            </v-card-title>
            <v-card-text>
              <div>Total horários: {{ dia.total }}</div>
              <div>Ocupados horários fixos: {{ dia.ocupadosHFixos }}</div>
              <div>Ocupados horários Livres: {{ dia.ocupadosHLivres }}</div>
              <div>Livres: {{ dia.livres }}</div>
              <div>Horários Fixos progressão</div>
              <v-progress-linear
                :value="(dia.ocupadosHFixos / dia.total) * 100"
                color="primary"
                height="8"
                class="mt-2"
                rounded
              />
              <div>Horários Livres progressão</div>
              <v-progress-linear
                :value="(dia.ocupadosHLivres / dia.total) * 100"
                color="secondary"
                height="8"
                class="mt-2"
                rounded
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <hr />

      <!-- Título da Seção Aulas -->
      <v-row>
        <v-col cols="12">
          <h1 class="font-weight-medium">{{ this.treinadorNome ?? 'Treinador' }} - Aulas</h1>
        </v-col>
        <v-col cols="12" md="2">
          <v-menu
            v-model="menuDatePickerAulaIni"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <ValidationProvider #default="{ errors }" name="Data Inicial">
                <v-text-field
                  v-model="data_inicial_aula"
                  label="Data Inicial"
                  prepend-inner-icon="mdi-calendar"
                  :error-messages="errors[0]"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                />
              </ValidationProvider>
            </template>
            <v-date-picker
              v-model="dataInicialAula"
              :active-picker.sync="ativarDatePickerAula"
              min="1900-01-01"
              locale="pt-BR"
            />
          </v-menu>
        </v-col>
        <v-col cols="12" md="2">
          <v-menu
            v-model="menuDatePickerAulaFin"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <ValidationProvider #default="{ errors }" name="Data final">
                <v-text-field
                  v-model="data_final_aula"
                  label="Data final"
                  prepend-inner-icon="mdi-calendar"
                  :error-messages="errors[0]"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                />
              </ValidationProvider>
            </template>
            <v-date-picker
              v-model="dataFinalAula"
              :active-picker.sync="ativarDatePickerAula"
              min="1900-01-01"
              locale="pt-BR"
            />
          </v-menu>
        </v-col>
        <v-col cols="6" md="2">
          <!-- Botão -->
          <v-btn color="primary" height="55" width="100%" @click="buscarGraficoLinha">
            <v-icon>mdi-chart-line</v-icon> Aulas
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12">
          <v-card v-if="listaDadosAlunos.length > 0">
            <GraficoAluno :dados="listaDadosAlunos" />
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="modalAberto" max-width="500">
        <v-card>
          <v-card-title>
            <span class="text-h6">{{ diaSelecionado?.nome }} - Detalhes</span>
          </v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item v-for="(h, i) in diaSelecionado?.horarios || []" :key="i">
                <v-list-item-content>
                  <!-- Tipo 0 -->
                  <div class="mb-2">
                    <v-row>
                      <v-col>
                        <v-list-item-title>
                          {{ h.horario }} → <strong>{{ h.vagas_livres_tipo_0 }}</strong> livres ({{
                            h.vagas_ocupadas_tipo_0
                          }}
                          vagas horário fixo ocupadas)
                        </v-list-item-title>
                      </v-col>
                      <v-col>
                        <v-chip :color="h.vagas_livres_tipo_0 > 0 ? 'green' : 'red'" dark small>
                          {{ h.vagas_livres_tipo_0 > 0 ? 'Disponível' : 'Cheio' }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Tipo 1 -->
                  <div>
                    <v-row>
                      <v-col>
                        <v-list-item-title>
                          {{ h.horario }} → <strong>{{ h.vagas_livres_tipo_1 }}</strong> livres ({{
                            h.vagas_ocupadas_tipo_1
                          }}
                          vagas horário livre ocupadas)
                        </v-list-item-title>
                      </v-col>
                      <v-col>
                        <v-chip :color="h.vagas_livres_tipo_1 > 0 ? 'green' : 'red'" dark small>
                          {{ h.vagas_livres_tipo_1 > 0 ? 'Disponível' : 'Cheio' }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="modalAberto = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <ModalLista
        v-model="modelValue"
        :titulo="getTituloModal"
        :dados="dadosModal"
        :itemKey="itemKey"
        :headers="colunasModal"
      />
    </v-container>
  </v-container>
</template>

<script>
const COLORS = {
  ENTRADAS: '#A0D995', // Verde claro pastel
  RENOVACOES: '#F5A17D', // Laranja claro pastel
  TRANSFERENCIAS: '#82C4E8', // Vermelho claro pastel
  SAIDAS: '#FF8A80', // Vinho claro pastel
  CONTRATOS: '#FF8F80', // Vinho claro pastel
};
const coresAcademias = {
  academais: {
    corLinha: '#FFB6C1', // Rosa pastel
    corAvatar: '#FFB347', // Rosa mais claro para o avatar
  },
  academia1: {
    corLinha: '#FFB6C1', // Rosa pastel
    corAvatar: '#FFDEE9', // Rosa mais claro para o avatar
  },
  academia2: {
    corLinha: '#87CEFA', // Azul pastel
    corAvatar: '#BFEFFF', // Azul mais claro para o avatar
  },
};
const LABELS = ['Entradas', 'Saídas', 'Transferências de Entrada', 'Transferências de Saída'];
const BKGRDCOLOR = [COLORS.ENTRADAS, COLORS.SAIDAS, COLORS.TRANSFERENCIAS, COLORS.RENOVACOES];
import _treinador from '@/services/treinador/treinador-servico.js';
import motivos from '../../models/tipo-motivo-transferencia.js';
import motivos_saida from '../../models/tipo-motivo-saida.js';
import util from '@/utils/utils.js';
// import GraficoBarras from "../AppGraficoBarra.vue"
import GraficoRosca from '../AppGraficoRosca.vue';
import GraficoAluno from '../AppGraficoAluno.vue';
// import GraficoLinha from "../AppGraficoLinha.vue"
// import GraficoLinhaMulti from "../AppGraficoLinhaMulti.vue"
import CardInfo from './CardInfo.vue';
import AppProduto from '@/components/AppProduto.vue';
import AppHistorico from '@/components/AppHistorico.vue';
import produtos from '../../models/produtos.js';
import ModalLista from '../Modais/ListaModal.vue';
import AlertaModal from '../Modais/AlertaModal.vue';
import ComboBox from '../ComboBox/ComboBox.vue';

export default {
  components: {
    // GraficoBarras,
    GraficoRosca,
    GraficoAluno,
    AppProduto,
    AppHistorico,
    ModalLista,
    ComboBox,
    AlertaModal,
    // GraficoLinha,
    // GraficoLinhaMulti,
    CardInfo,
  },
  data() {
    return {
      carregando: false,
      configuracaoSelecionada: null,
      mostrarAlerta: false,
      mensagemAlerta: '',
      itemKey: null,
      dadosApi: [],
      nomesSemana: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      modalAberto: false,
      diaSelecionado: null,
      modelValue: false,
      colunasModal: [],
      dadosModal: [],
      tituloModal: '',
      dialog: false,
      alunos: [],
      alunoSelecionado: [],
      headers: [
        { text: 'Nome', value: 'nome' },
        { text: 'Produto', value: 'produto' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Academia', value: 'academia' },
        { text: 'Detalhes', value: 'actions', sortable: false },
      ],
      listaDados: [],
      listaDadosAlunos: [],
      treinador_id: null,
      treinadorNome: null,
      treinadores: [],
      treinadorSelecionado: null,
      treinador: {
        entradas: 0,
        saidas: 0,
        transferenciasSaidas: 0,
        transferenciasEntradas: 0,
      },
      treinadorIndicadores: {
        totalAlunos: 0,
        totalAlunosAcademia: 0,
        valorTotalMensalidades: 0,
        ltv: 0,
        totalGanhos: 0,
        totalPerdidos: 0,
        totalVamoMexe: 0,
        totalVMConvertido: 0,
      },
      vamoMexeDados: [],
      coresAcademias,
      chartLinhaContratosSilva: [],
      chartLinhaContratosMedianeira: [],

      chartDataTotal: {
        labels: LABELS,
        datasets: [
          {
            backgroundColor: BKGRDCOLOR,
            data: [],
          },
        ],
      },
      chartDataAcademia1: {
        labels: LABELS,
        datasets: [
          {
            backgroundColor: BKGRDCOLOR,
            data: [],
          },
        ],
      },
      chartDataAcademia2: {
        labels: LABELS,
        datasets: [
          {
            backgroundColor: BKGRDCOLOR,
            data: [],
          },
        ],
      },
      situacao: null,

      data_inicial: null,
      data_final: null,
      dataInicial: null,
      dataFinal: null,
      menuDatePickerI: false,
      menuDatePickerF: false,
      ativarDatePicker: null,

      data_inicial_mov: null,
      data_final_mov: null,
      dataInicialMovimentacao: null,
      dataFinalMovimentacao: null,
      menuDatePickerMovIni: false,
      menuDatePickerMovFin: false,
      ativarDatePickerMov: null,

      data_inicial_aula: null,
      data_final_aula: null,
      dataInicialAula: null,
      dataFinalAula: null,
      menuDatePickerAulaFin: false,
      menuDatePickerAulaIni: false,
      ativarDatePickerAula: null,

      cardSelecionado: null,

      selectedTrainer: null,

      produtosSelecionados: [],

      academia: null,
      academias: [],
      produtosTreinador: [],

      trainers: [
        { id: 1, name: 'João Silva' },
        { id: 2, name: 'Maria Oliveira' },
      ],

      chartData: {
        labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul'],
        datasets: [{ label: 'Aulas', data: [] }],
      },
    };
  },

  async mounted() {
    // Criar uma nova data
    let dataAtual = new Date();

    // Definir o primeiro dia do mês
    let primeiroDia = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);

    // Definir o último dia do mês
    let ultimoDia = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);

    let primeiroDiaFormatado = util.converterFormatoPtBr(primeiroDia.toISOString());
    let ultimoDiaFormatado = util.converterFormatoPtBr(ultimoDia.toISOString());

    this.data_inicial = primeiroDiaFormatado;
    this.data_final = ultimoDiaFormatado;
    this.data_inicial_mov = primeiroDiaFormatado;
    this.data_final_mov = ultimoDiaFormatado;
    this.data_inicial_aula = primeiroDiaFormatado;
    this.data_final_aula = ultimoDiaFormatado;
    await this.listarTreinadores();
    // this.listarEstatisticas();
  },
  watch: {
    dataInicial() {
      this.data_inicial = util.converterFormatoPtBr(this.dataInicial);
    },
    dataFinal() {
      this.data_final = util.converterFormatoPtBr(this.dataFinal);
    },
    dataInicialMovimentacao() {
      this.data_inicial_mov = util.converterFormatoPtBr(this.dataInicialMovimentacao);
    },
    dataFinalMovimentacao() {
      this.data_final_mov = util.converterFormatoPtBr(this.dataFinalMovimentacao);
    },
    dataInicialAula() {
      this.data_inicial_aula = util.converterFormatoPtBr(this.dataInicialAula);
    },
    dataFinalaula() {
      this.data_final_aula = util.converterFormatoPtBr(this.dataFinalAula);
    },
    treinadorSelecionado() {
      this.configuracaoSelecionada = null;
      this.academia = null;
      this.produtosSelecionados = [];

      this.produtosTreinador = this.treinadorSelecionado.produtos.map(produto => ({
        text: produtos[produto].text,
        value: produto,
        color: produtos[produto].color,
      }));
      this.academias = this.treinadorSelecionado.academias.map(academia => ({
        nome: academia.id == 1 ? 'Silva' : 'Medianeira',
        id: academia.id,
      }));
      this.treinadorNome = this.treinadorSelecionado.nome;
    },
  },
  computed: {
    nivelTreinador() {
      return this.getNivel(this.indicadoresTreinador.totalAlunos ?? 0);
    },
    getTituloModal() {
      return this.tituloModal;
    },
    dadosFormatados() {
      return this.dadosApi.map(d => {
        const total = d.horarios.length * 10;
        const ocupadosHFixos = d.horarios.reduce((soma, h) => soma + h.tipo_0, 0);
        const ocupadosHLivres = d.horarios.reduce((soma, h) => soma + h.tipo_1, 0);
        return {
          nome: this.nomesSemana[d.dia_semana],
          dia_semana: d.dia_semana,
          total,
          ocupadosHFixos,
          ocupadosHLivres,
          livres: total - ocupadosHFixos - ocupadosHLivres,
          horarios: d.horarios.map(h => ({
            horario: h.horario,
            vagas_ocupadas_tipo_0: h.tipo_0,
            vagas_ocupadas_tipo_1: h.tipo_1,
            vagas_livres_tipo_0: 6 - h.tipo_0,
            vagas_livres_tipo_1: 4 - h.tipo_1,
            tipo_0: h.tipo_0,
            tipo_1: h.tipo_1,
          })),
        };
      });
    },
    getDadosVamoMexe() {
      return this.vamoMexeDados;
    },
    alunosFormatados() {
      return this.listaDados.map(item => ({
        aluno_id: item.aluno_id,
        nome: item.nome?.trim() || '—',
        produto: item.produto,
        tipo: item.tipo,
        academia: item.academia_id == 1 ? 'Silva' : 'Medianeira',
        data_inicial: item.data_inicial ? util.formatarDataTela(item.data_inicial) : '—',
        data_final: this.getDataFinal(item.data_final, item.tipo),
        motivo: item.motivo
          ? item.tipo == 2
            ? motivos_saida[item.motivo - 1].text
            : motivos[item.motivo - 1].text
          : '—',
        aniversario: item.aniversario ? this.getAniversario(item.aniversario) : '—',
      }));
    },
    indicadoresTreinador() {
      return this.treinadorIndicadores;
    },
    bonificacaoTreinador() {
      let comBonus = true;
      let frase = '';
      const fraseSemBonus = {
        alunos: '< 200 alunos',
        perdidos: 'saída: acima de ',
        semFrase: 0,
      };
      const { totalAlunos, totalPerdidos, totalAlunosAcademia, valorTotalMensalidades } =
        this.indicadoresTreinador;
      const { porcentagem, valorFixo } = this.getNivel(totalAlunos);
      const bonus = { percent: porcentagem, valorFixo: valorFixo };
      if (totalAlunosAcademia <= 200) {
        comBonus = false;
        frase = fraseSemBonus.alunos;
      } else {
        if ((totalPerdidos * 100) / totalAlunos > 8) {
          comBonus = false;
          frase = fraseSemBonus.perdidos + ((totalPerdidos * 100) / totalAlunos).toFixed(0) + '%';
        }
      }
      if (totalAlunos === 0) {
        comBonus = false;
        frase = fraseSemBonus.semFrase;
      }

      return {
        porcent: comBonus ? bonus['percent'] + '%' : '0%',
        bonus: comBonus
          ? (bonus['percent'] * valorTotalMensalidades) / 100 + bonus['valorFixo']
          : frase,
        fixo: comBonus ? 'R$' + bonus['valorFixo'] : 'R$ 0,00',
      };
    },
  },
  methods: {
    salvarConfiguracao() {
      if (
        this.academia == null ||
        !this.treinadorSelecionado == null ||
        this.produtosSelecionados.length === 0
      ) {
        this.mensagemAlerta = 'Selecione treinador, um produto pelo menos e a academia.';
        this.mostrarAlerta = true;
        return;
      }

      this.configuracaoSelecionada = {
        treinador_id: this.treinadorSelecionado.id,
        produtoArray: this.selectedProdutos(),
        academia_id: this.academia.id,
      };
      this.mensagemAlerta = 'Selecão salva.';
      this.mostrarAlerta = true;
    },

    getInfosCards() {
      if (!this.configuracaoSelecionada) {
        return this.alertaConfiguracao();
      }
      this.buscarCards();
    },

    buscarGraficoRosca() {
      if (!this.configuracaoSelecionada) {
        return this.alertaConfiguracao();
      }
      this.buscarMovimentacoes();
    },

    buscarHorarios() {
      if (!this.configuracaoSelecionada) {
        return this.alertaConfiguracao();
      }
      this.buscarAgenda();
    },

    buscarGraficoLinha() {
      if (!this.configuracaoSelecionada) {
        return this.alertaConfiguracao();
      }
      this.buscarAulasAlunos();
    },
    selectedProdutos() {
      return this.produtosSelecionados.map(item => item.value);
    },
    onValuesChange(valores) {
      console.log('Somente values selecionados:', valores);
    },
    abrirDetalhes(dia) {
      this.diaSelecionado = dia;
      this.modalAberto = true;
    },
    getNivel(alunos) {
      if (alunos <= 24) {
        return { nome: 'Lobinho', icon: 'mdi-paw', porcentagem: 0, valorFixo: 0 }; // pegada de lobo
      }
      if (alunos >= 25 && alunos <= 40) {
        return { nome: 'Treinador', icon: 'mdi-whistle', porcentagem: 1, valorFixo: 200 }; // apito de treinador
      }
      if (alunos >= 41 && alunos <= 55) {
        return { nome: 'Líder', icon: 'mdi-account-tie', porcentagem: 2, valorFixo: 300 }; // pessoa com gravata
      }
      if (alunos >= 56 && alunos <= 70) {
        return { nome: 'Guardião', icon: 'mdi-shield-check', porcentagem: 5, valorFixo: 400 }; // escudo com check
      }
      if (alunos >= 71) {
        return { nome: 'Mestre', icon: 'mdi-star-circle', porcentagem: 5, valorFixo: 1000 }; // estrela de mestre
      }
    },
    dialogAluno(item) {
      this.alunoSelecionado = item;
      this.dialog = true;
    },
    loadTrainerData() {
      // Simulação de dados do treinador ao selecionar no dropdown
      const dataMock = {
        1: { totalAlunos: 25, ticketMedio: 150, aulas: [5, 10, 15, 20, 25, 30, 35] },
        2: { totalAlunos: 40, ticketMedio: 200, aulas: [10, 15, 20, 25, 30, 35, 40] },
      };

      this.trainerData = dataMock[this.selectedTrainer] || { totalAlunos: 0, ticketMedio: 0 };
      this.chartData.datasets[0].data = this.trainerData.aulas;
    },

    async listarTreinadores() {
      this.treinadores = (await _treinador.listarTreinadoresAtivosRelatorios()).map(treinador => ({
        id: treinador.id,
        nome: treinador.nome,
        produtos: treinador.produtos,
        academias: treinador.academias,
      }));
    },
    async buscarCards() {
      this.carregando = true;
      var filtrosTreinador = {
        treinador_id: this.treinadorSelecionado.id,
        situacao: 1,
        data_ate: util.formatarData(this.data_final),
        produtoArray: this.selectedProdutos(),
        academia_id: this.academia.id,
      };
      _treinador.buscarRelatorioTreinador(filtrosTreinador).then(response => {
        this.carregando = false;
        this.vamoMexeDados = response.vamo_mexe;
        this.treinadorIndicadores.totalAlunos = response.treinador.total_alunos;
        this.treinadorIndicadores.valorTotalMensalidades = response.treinador.total_mensalidades;
        this.treinadorIndicadores.ltv = response.treinador.ltv_total;
        this.treinadorIndicadores.totalGanhos = response.treinador.total_ganhos;
        this.treinadorIndicadores.totalPerdidos = response.treinador.total_perdidos;
        this.treinadorIndicadores.totalAlunosAcademia = response.treinador.total_alunos_academia;
        this.treinadorIndicadores.totalVamoMexe = response.treinador.total_vamo_mexe;
        this.treinadorIndicadores.totalVMConvertido = response.treinador.total_vm_convertido;
      });
    },
    async buscarMovimentacoes() {
      this.carregando = true;
      var filtros = {
        data_de: util.formatarData(this.data_inicial_mov),
        data_ate: util.formatarData(this.data_final_mov),
        situacao: this.situacao ? 2 : null,
        produtoArray: this.selectedProdutos(),
        treinador_id: this.treinadorSelecionado.id,
      };
      _treinador.buscarRelatorioAlunos(filtros).then(response => {
        this.carregando = false;
        this.listaDados = response;
        this.atualizarGrafico();
      });
    },

    async buscarAgenda() {
      this.carregando = true;
      _treinador.buscarDisponibilidadeTreinador(this.treinadorSelecionado.id).then(response => {
        this.carregando = false;
        this.dadosApi = response;
      });
    },

    async buscarAulasAlunos() {
      this.carregando = true;
      var filtros = {
        data_de: util.formatarData(this.data_inicial_aula),
        data_ate: util.formatarData(this.data_final_aula),
        situacao: this.situacao ? 2 : null,
        treinador_id: this.treinadorSelecionado.id,
      };
      this.listaDadosAlunos = [];
      this.listaDadosAlunos = await _treinador.buscarRelatorioAulasAlunos(filtros);
      this.carregando = false;
    },
    // async listarEstatisticas() {
    //   var filtros = {
    //     data_de: util.formatarData(this.data_inicial),
    //     data_ate: util.formatarData(this.data_final),
    //     situacao: this.situacao ? 2 : null,
    //     treinador_id: this.treinadorSelecionado.id,
    //   };
    //   this.listaDadosAlunos = [];
    //   this.listaDadosAlunos = await _treinador.buscarRelatorioAulasAlunos(filtros);

    //   this.treinadorNome = this.treinadorSelecionado.nome;
    //   _treinador.buscarRelatorioAlunos(filtros).then(response => {
    //     this.listaDados = response;
    //     this.atualizarGrafico();
    //   });
    //   var filtrosTreinador = {
    //     treinador_id: this.treinadorSelecionado.id,
    //     situacao: 1,
    //     data_ate: util.formatarData(this.data_final),
    //     produtoArray: this.selectedProdutos(),
    //     academia_id: this.academia.id,
    //   };
    //   _treinador.buscarRelatorioTreinador(filtrosTreinador).then(response => {
    //     this.vamoMexeDados = response.vamo_mexe;
    //     this.treinadorIndicadores.totalAlunos = response.treinador.total_alunos;
    //     this.treinadorIndicadores.valorTotalMensalidades = response.treinador.total_mensalidades;
    //     this.treinadorIndicadores.ltv = response.treinador.ltv_total;
    //     this.treinadorIndicadores.totalGanhos = response.treinador.total_ganhos;
    //     this.treinadorIndicadores.totalPerdidos = response.treinador.total_perdidos;
    //     this.treinadorIndicadores.totalAlunosAcademia = response.treinador.total_alunos_academia;
    //     this.treinadorIndicadores.totalVamoMexe = response.treinador.total_vamo_mexe;
    //     this.treinadorIndicadores.totalVMConvertido = response.treinador.total_vm_convertido;
    //   });

    //   _treinador.buscarDisponibilidadeTreinador(this.treinadorSelecionado.id).then(response => {
    //     this.dadosApi = response;
    //   });
    // },
    atualizarGrafico() {
      this.zerarContadoresTreinador();

      this.listaDados.forEach(aluno => {
        switch (aluno.tipo) {
          case 1:
            this.treinador.entradas += 1;
            break;
          case 2:
            this.treinador.saidas += 1;
            break;
          case 3:
            this.treinador.transferenciasEntradas += 1;
            break;
          case 4:
            this.treinador.transferenciasSaidas += 1;
            break;
          default:
            this.treinador.transferenciasSaidas += 1;
            break;
        }
      });
      this.chartDataTotal.datasets[0].data = [
        this.treinador.entradas,
        this.treinador.saidas,
        this.treinador.transferenciasEntradas,
        this.treinador.transferenciasSaidas,
      ];
    },

    zerarContadoresTreinador() {
      this.treinador.entradas = 0;
      this.treinador.saidas = 0;
      this.treinador.transferenciasEntradas = 0;
      this.treinador.transferenciasSaidas = 0;
    },

    popularTabela(index = null, selecionado = 'Todos') {
      this.cardSelecionado = selecionado;
      this.alunos =
        index === null
          ? this.listaDados[0].alunos.concat(this.listaDados[1].alunos)
          : this.listaDados[index].alunos;
    },

    getDataFinal(dataFinal, tipo) {
      if (tipo == 1) return '';
      return dataFinal ? util.formatarDataTela(dataFinal) : '—';
    },

    getAniversario(aniversario) {
      const mes = aniversario.split('-')[1];
      const dia = aniversario.split('-')[2];
      const ano = new Date().getFullYear();
      const dataAniversario = `${ano}-${mes}-${dia}`;

      return util.formatarDataTela(dataAniversario);
    },

    async abrirModal(item, index, academiaId, data = []) {
      const param = this.getItemModal(index);
      if (index <= 3) {
        const renovacao = index === 3 ? 2 : 0;
        var filtros = {
          data_de: util.formatarData(this.data_inicial),
          data_ate: util.formatarData(this.data_final),
          situacao: this.situacao ? 2 : 1,
          produtoArray: this.selectedProdutos(),
          academia_id: academiaId,
          renovacao: renovacao,
        };
      }
      this.dadosModal = index <= 3 ? await this.getDadosModal(filtros, param) : data;
      this.colunasModal = this.getColunasModal(index);
      this.tituloModal = `Detalhes: ${item}`;
      this.modelValue = true;
      this.itemKey = this.getItemKey(index);
    },
    getItemModal(index) {
      switch (index) {
        case 0:
          return 'contratos';

        case 1:
          return 'saidas';

        case 2:
          return 'transferencias';

        case 3:
          return 'contratos';

        default:
          return 'academia2';
      }
    },

    getColunasModal(index) {
      switch (index) {
        case 4: //entradas
          return [
            { text: 'Nome', value: 'nome' },
            { text: 'Telefone', value: 'telefone' },
            { text: 'Data', value: 'data_inicial' },
            { text: 'Status', value: 'status' },
          ];

        default:
          return 'academia2';
      }
    },

    alertaConfiguracao() {
      this.mensagemAlerta = 'Salve a configuração primeiro.';
      return (this.mostrarAlerta = true);
    },

    getItemKey(index) {
      switch (index) {
        case 0:
          return 'aluno_id';

        case 1:
          return 'usuario_id';

        case 2:
          return 'aluno_id';

        case 3:
          return 'aluno_id';

        default:
          return 'aluno_id';
      }
    },
  },
};
</script>

<style scoped>
hr {
  color: #ececec;
  opacity: 30%;
  margin-bottom: 20px;
  margin-top: 20px;
}
.v-avatar .v-icon {
  color: white !important;
}
</style>
